export const REQUEST = Symbol('REQUEST');
export const RESPONSE = Symbol('RESPONSE');
export const SSR_URL = Symbol('SSR_URL');
